import { Component, inject, input, signal, computed, OnInit } from '@angular/core';
import { HaulierItem, HaulierItemAuditTrailItem } from '@hjc/masterdata-types';
import { AuditTrailService } from '@services/audit-trail.service';
import { PartnersService } from '@services/partners.service';
import { AuditTrailComponent } from '@components/audit-trail/audit-trail.component';
import { PageHeaderComponent } from '@components/page-header/page-header.component';
import { InfoComponent, InfoField } from '@components/info/info.component';

@Component({
  selector: 'md-view-logistics-details',
  imports: [PageHeaderComponent, InfoComponent, AuditTrailComponent],
  templateUrl: './view-logistics-details.component.html',
  styleUrl: './view-logistics-details.component.scss',
  standalone: true
})
export class ViewLogisticsDetailsComponent implements OnInit {
  private partnersService = inject(PartnersService);
  private auditTrailService = inject(AuditTrailService);

  logisticPartnerItem = signal<HaulierItem | undefined>(undefined);
  auditTrail = signal<HaulierItemAuditTrailItem[]>([]);

  haulierId = input.required<string>();

  infoFields = computed<InfoField[]>(() => [
    { key: 'id', labelKey: 'FIELDS.IDENTIFIER', type: 'string' },
    { key: 'licenseId', labelKey: 'FIELDS.LICENSE_NUMBER', type: 'string' },
    { key: 'address', labelKey: 'FIELDS.STREET_ADDRESS', type: 'string' },
    { key: 'zip', labelKey: 'FIELDS.POSTAL_CODE', type: 'string' },
    { key: 'city', labelKey: 'FIELDS.CITY', type: 'string' },
    { key: 'createdAt', labelKey: 'FIELDS.SYSTEM.CREATED_AT', type: 'date', pipe: 'date', dateFormat: 'dd.MM.yyyy HH:mm' },
    { key: 'createdBy', labelKey: 'FIELDS.SYSTEM.CREATED_BY', type: 'string' },
    { key: 'updatedAt', labelKey: 'FIELDS.SYSTEM.UPDATED_AT', type: 'date', pipe: 'date', dateFormat: 'dd.MM.yyyy HH:mm' },
    { key: 'updatedBy', labelKey: 'FIELDS.SYSTEM.UPDATED_BY', type: 'string' }
  ]);

  ngOnInit(): void {
    const id = this.haulierId();
    if (id) {
      this.loadLogisticPartnerItem(id);
      this.loadAuditTrail(id);
    }
  }

  private async loadLogisticPartnerItem(id: string): Promise<void> {
    try {
      const response = await this.partnersService.getLogisticPartnerById(id);
      this.logisticPartnerItem.set(response?.data);
    } catch (error) {
      console.error('Error loading slaughterhouse data:', error);
    }
  }

  private async loadAuditTrail(id: string): Promise<void> {
    try {
      const response = await this.auditTrailService.getAuditTrail<HaulierItemAuditTrailItem>('haulier', id);
      this.auditTrail.set(response?.data || []);
    } catch (error) {
      console.error('Error loading audit trail:', error);
    }
  }
}
